import React, { Component } from 'react';

import './style.css';
class PolicyPage extends Component {
  render() {
    return (
      <div>

        <center>
			<div id="header0">PRIVACY POLICY</div>
			<div id="content0">Sleep Timer application</div>
			<div id="content0">Last modified on Dec 22, 2018</div>
		</center>
		
		<div id="content2">
		We do not collect any your data. All permissons which we request only purpose for application's functions.
		All permissions of this app are describe as below:
		</div>
        
		<div id="header2">ACCESS_WIFI_STATE</div>
        <div id="content2">
		Required for the "Turn off Wifi" feature. It allows application get Wifi state: ON or OFF, so application should turn off in case Wifi is ON.
		</div>
		
		<div id="header2">CHANGE_WIFI_STATE</div>
        <div id="content2">
		Required for the "Turn off Wifi" feature. It allows application to turn off Wifi.
		</div>
		
		<div id="header2">BLUETOOTH</div>
        <div id="content2">
		Required for the "Turn off Bluetooth" feature. It allows application get Bluetooth state: ON or OFF, so application should turn off in case Bluetooth is ON.
		</div>
		
		<div id="header2">BLUETOOTH_ADMIN</div>
        <div id="content2">
		Required for the "Turn off Bluetooth" feature. It allows application to turn off Bluetooth.
		</div>
		
		<div id="header2">FOREGROUND_SERVICE</div>
        <div id="content2">
		It allows application to start foreground in a service, application needs it to show an notification from service.
		</div>
		
		<div id="header2">INTERNET</div>
        <div id="content2">
		It allows application get new configurations.
		</div>
		
		<div id="header2">android.permission.BIND_DEVICE_ADMIN</div>
        <div id="content2">
		Required for the "Turn off screen" feature. This sleep timer app uses DEVICE MANAGER permission. It allow application to control how and when the screen locks.
		</div>
		
		<div id="header2">Changes</div>
        <div id="content2">
		We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.	
		</div>
		
		<div id="header2">Contact Us</div>
        <div id="content2">
		If you have any questions, or to report any violations of the Policy, please contact us at reping.dev@gmail.com.
		</div>
      </div>
    );
  }
}

export default PolicyPage;



// WEBPACK FOOTER //
// ./src/Privacy Policy/SleepTimer/index.js